import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
import { useTable } from "@/hooks/useTable";
import { ListFooter } from "@/components/shared/list-footer";

import { ErrorBoundary } from "react-error-boundary";
import { RecordNotFound } from "@/components/shared/record-not-found";
import { TableColumnsHandle } from "@/components/shared/table-columns-handle";
import { Columns3Icon, FilterIcon, X } from "lucide-react";
import { useMutations } from "./utils/react-hook/use-mutations";
import { ReactTable, ReactTableSkelton } from "./utils";
import { Fragment } from "react/jsx-runtime";
import ErrorFallback from "@/components/shared/error-fallback";
import { ConditionRenderer } from "@/components/shared/condition-renderer";

export const EmailReadLogs = () => {
  const {
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,

    skeltonLoading,
    tableColumn,
    setTableColumn,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
  } = useMutations();

  const {
    tableHeader,
    table,
    tableKeys,
    // toggleSelection,
    // rowSelection,
    onResize,
    onSorting,
    // loading,
  } = useTable({
    data: listData,
    view: [
      "read_at",
      "read_emails",
      "read_attachments",
      "status",
      "sender_email",
      "error",
      "ignored_attachments",
      "total_attachments",
      "total_emails",
      "receiver_email",
      "email_provider",
      "email_id",
    ],
    verifyKey: "email_read_logs",
    visible: tableColumn,
    avoid: [""],
    // columnSize: {
    //   read_at: 108,
    //   read_emails: 90,
    //   read_attachments: 117,
    //   status: 100,
    //   sender_email: 100,
    //   error: 65,
    //   ignored_attachments: 100,
    //   total_attachments: 100,
    //   total_emails: 65,
    //   receiver_email: 150,
    //   email_provider: 65,
    //   email_id: 150,
    // },
  });

  return (
    <Fragment>
      <div className="flex flex-col gap-5">
        <ListPageTopBar title="Email read logs">
          <TableColumnsHandle
            tableKeys={tableKeys}
            tableColumn={tableColumn}
            setTableColumn={setTableColumn}
            onSorting={onSorting}
            tableKey="email_read_logs"
            labels={{
              status: "Status",
              email_provider: "Email Provider",
              error: "Error",
              ignored_attachments: "Ignored Attachments",
              read_at: "Read At",
              read_attachments: "Read Attachments",
              read_emails: "Read Emails",
              receiver_email: "Receiver Email",
              sender_email: "Sender Email",
              total_attachments: "Total Attachments",
              total_emails: "Total Emails",
            }}
          >
            <Columns3Icon /> Column
          </TableColumnsHandle>

          <ConditionRenderer condition={Object.keys(filter).length !== 0}>
            <>
              <Button variant={"action"} onClick={filterRequest}>
                <FilterIcon /> Filter
              </Button>
              <Button variant={"action"} onClick={clearFilter}>
                <X /> Clear Filter
              </Button>
            </>
          </ConditionRenderer>

          {/* <Button variant={"action"} onClick={() => onFormOpenChange(true)}>
              + Create
            </Button> */}
        </ListPageTopBar>

        {skeltonLoading ? (
          <ReactTableSkelton />
        ) : (
          <Card className="overflow-hidden">
            <CardContent className="max-w-[100%] p-0 overflow-auto scrollbar h-auto min-h-[350px] md:h-[calc(100dvh-340px)]">
              <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => (
                  <ErrorFallback
                    error={error}
                    errorInfo={error.stack || ""}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
              >
                <ReactTable
                  tableHeader={tableHeader}
                  onResize={onResize}
                  table={table}
                  permission={permission}
                  filter={filter}
                  setFilter={setFilter}
                  listData={listData}
                  filterRequest={filterRequest}
                />
                {table.length === 0 ? <RecordNotFound /> : null}
              </ErrorBoundary>
            </CardContent>
            <ErrorBoundary
              fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorFallback
                  error={error}
                  errorInfo={error.stack || ""}
                  resetErrorBoundary={resetErrorBoundary}
                />
              )}
            >
              <hr />
              <ListFooter
                onPageChange={onPageChange}
                onPerPageChange={onPerPageChange}
                page={paginationData.page}
                perPage={paginationData.perPage}
                totalItem={paginationData.totalItem}
                className="px-5 py-5"
                isEmpty={table.length === 0}
              />
            </ErrorBoundary>
          </Card>
        )}
      </div>
    </Fragment>
  );
};
